export default {
  getTeam: (state, team) => {
    state.get = team
  },
}
